import URLParse from "url-parse";
import DokumentBoxApi from "mc/lib/api/gen/dokumentybox/DokumentBoxApi";
import * as ModuleCode from "mc/lib/api/gen/proxioapi/v1/ModuleCode";

export function findCertificates(requestId, url = getUrl()) {
    return get(requestId, 'marbessign:list|' + requestId + '|' + url).then(() => {
        return new Promise((resolve, reject) => {
            const timerInterval = 1000;
            const timerTimeout = 15000;

            let counter = 0;
            let req = null;
            let hasResponse = false;
            let response = null;
            const timer = setInterval(function () {
                counter++;
                const timedOut = counter > timerTimeout/timerInterval;
                if (!hasResponse && req === null) {
                    req = DokumentBoxApi.findCertificates(ModuleCode.MARBES, requestId).then((data) => {
                        req = null;
                        if (Array.isArray(data)) {
                            hasResponse = true;
                        }
                        response = data;
                    })
                }
                if (timedOut || hasResponse) {
                    clearInterval(timer);
                    if (timedOut) {
                        return reject(response);
                    } else {
                        return sleep(500).then(() => resolve(response));
                    }
                }
            }, timerInterval);
        })
    });
}

export function signDocumentFile(requestId, thumbprint, url = getUrl()) {
    return get(requestId, 'marbessign:multisign|' + requestId + '|' + url + '|' + thumbprint);
}

function getUrl() {
    const p = new URLParse(serverContextPath);
    return p.origin + serverContextPath;
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function get(id, url) {
    return new Promise((resolve, reject) => {
        const frameId = "getFrame-" + id;
        const timerInterval = 1000;
        const timerTimeout = 40000;

        if(document.getElementById(frameId)) {
            return reject();
        }

        const downloadFrame = document.createElement('iframe');
        downloadFrame.src = url;
        downloadFrame.id = frameId;
        downloadFrame.style.display="none";
        document.body.appendChild(downloadFrame);

        let counter = 0;
        const timer = setInterval(function () {
            counter++;
            const timedOut = counter > timerTimeout/timerInterval;
            let f = document.hasFocus();
            if (timedOut || f) {
                clearInterval(timer);
                downloadFrame.parentElement.removeChild(downloadFrame);
                if (timedOut) {
                    return reject();
                } else {
                    return sleep(500).then(() => resolve());
                }
            }
        }, timerInterval);
    });
}
